const BagIcon = ({ ...props }) => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" {...props}>
      <path
        d="M11.3013 4.85244C10.6849 4.17281 3.73035 4.07562 2.67391 4.85244C1.61746 5.62925 -1.37566 14.1747 0.737468 14.5631C2.05769 15.1458 12.1817 15.1458 13.4141 14.5631C15.3509 13.0094 11.9177 5.53206 11.3013 4.85244Z"
        fill="white"
      />
      <path
        d="M4.85938 6.05556V3.19392C4.85938 3.19392 4.85938 1 6.90104 1C8.94271 1 8.94271 3.19392 8.94271 3.19392V6.05556"
        stroke="white"
      />
    </svg>
  )
}

export default BagIcon
